import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { I18nService } from '@core/i18n-legacy';
import type { SelectOption } from '@core/user-interface-legacy';
import { SelectComponent } from '@core/user-interface-legacy';

import { Destroyable, takeUntilDestroyed } from '../../../common';
import type { DynamicRegionSelectInputConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';
import { DynamicFormLocationsService } from '../dynamic-form/dynamic-form-locations-service';

export class RegionSelectInput extends DynamicFormInput<DynamicRegionSelectInputConfig> {}

@Component({
  selector: 'rti-region-select-input',
  templateUrl: './region-select-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectComponent],
})
@Destroyable()
export class RegionSelectInputComponent {
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly i18n = inject(I18nService);
  private readonly locationSvc = inject(DynamicFormLocationsService);

  public readonly input = input<RegionSelectInput>(undefined!);

  public loading: boolean = false;
  public regionOptions: Array<SelectOption<string>> = [];

  public ngOnInit(): void {
    this.locationSvc.loadingRegions$.pipe(takeUntilDestroyed(this)).subscribe(loading => {
      this.loading = loading;
      this.cdRef.detectChanges();
    });

    this.locationSvc.regions$.pipe(takeUntilDestroyed(this)).subscribe(countries => {
      this.regionOptions = countries;
      this.cdRef.detectChanges();
    });
  }

  public get selectPlaceholder(): string | undefined {
    return this.loading ? this.i18n.translate('rti.common.loading') : undefined;
  }
}
